import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SharedService } from "../services/shared.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-reset-password",
  templateUrl: "./reset-password.component.html",
  styleUrls: ["./reset-password.component.css"],
  providers:[SharedService]
})
export class ResetPasswordComponent implements OnInit {
  type: string;
  resetForm: FormGroup;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe((data: any) => {
      this.type = data.params.type;
    });
    this.resetForm = this.formBuilder.group({
      email: ["", [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
    });
  }

  signIn() {
    if (this.type === "Scholar") {
      this.router.navigate(["/register/scholar"]);
    }
    if (this.type === "Mentor") {
      this.router.navigate(["/register/mentor"]);
    }
    if (this.type === "Co-ordinator") {
    }
  }
  resetPassword() {
    if (this.resetForm.invalid) {
      return;
    }
    const email = this.resetForm.value.email;
    this.sharedService.initiatePasswordReset(email, this.type).subscribe(
      (res: any) => {
        Swal.fire({
          type: "success",
          title: res.message,
          timer: 3000,
          showCancelButton: false,
          showConfirmButton: false,
        }).then(
          // Handle success, e.g., redirect to a success page or update UI
        );
      },
      (error) => {
        // Handle error, e.g., show error message to the user
        Swal.fire({
          type: "error",
          title: "Error",
          text: error.error.message, // Display the error message from the server
          showCancelButton: false,
          showConfirmButton: true,
        });
      }
    );
    
  }
}
